import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {FeatureGroupTypeService} from '@catcore/services';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class FeatureGroupTypeResolve implements Resolve<any> {
  constructor(protected service: FeatureGroupTypeService,
              protected router: Router
  ) {
  }

  /**
   * Loads the project-info based on a provided :projectId and returns a Observable
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return this.service.getAll();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/services/feature-group-type.resolve.ts